import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class ReportBestSelingService {
    async getList(params: any, page: string, size: string): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.BEST_SELLING_PRODUCTS}?size=${size}&page=${page}`, params);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }
}

const reportBestSelingService = new ReportBestSelingService();
export default reportBestSelingService;